import React, { memo, FC } from 'react';
import { ICounterBox } from 'types/components';
import 'assets/scss/counterBox.scss';

const CounterBox: FC<ICounterBox> = ({ children, withTags, showOptOutFooter }) => {
    return (
        <div className={`counter-box ${withTags ? 'with-tags' : ''} ${showOptOutFooter ? 'with-footer' : ''} `}>
            {children}
        </div>
    );
};

export default memo(CounterBox);
